import React from 'react';
import { Settings, Bell, Database, Shield, Globe } from 'lucide-react';

export default function SettingsView() {
    return (
        <div className="p-8 max-w-4xl mx-auto space-y-8 animate-in fade-in duration-500">
            <div className="flex items-center gap-3 border-b border-border/10 pb-6">
                <div className="p-3 bg-primary/10 rounded-xl text-primary">
                    <Settings className="w-8 h-8" />
                </div>
                <div>
                    <h1 className="text-3xl font-bold text-foreground tracking-tight">System Settings</h1>
                    <p className="text-muted-foreground mt-1">Configure global preferences and integrations</p>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* General */}
                <Section title="General Preferences" icon={Globe}>
                    <SettingRow label="Language" value="English (US)" />
                    <SettingRow label="Timezone" value="EST (UTC-5)" />
                    <SettingRow label="Units" value="Metric" />
                </Section>

                {/* Notifications */}
                <Section title="Notifications" icon={Bell}>
                    <SettingToggle label="Alerts (SMS)" active={true} />
                    <SettingToggle label="Email Reports" active={false} />
                    <SettingToggle label="Push Notifications" active={true} />
                </Section>

                {/* Data */}
                <Section title="Data Source" icon={Database}>
                    <SettingRow label="Satellite Provider" value="Sentinel-2" />
                    <SettingRow label="Sensor IoT Hub" value="Connected (4 Nodes)" color="text-green-500" />
                    <SettingRow label="Sync Frequency" value="Every 60s" />
                </Section>

                {/* Security */}
                <Section title="Security" icon={Shield}>
                    <SettingRow label="Role" value="Field Admin" />
                    <SettingRow label="Last Login" value="2026-01-24 10:42 AM" />
                </Section>
            </div>

            <div className="flex justify-end pt-8">
                <button className="px-6 py-2 bg-primary text-primary-foreground font-semibold rounded-lg hover:bg-primary/90 transition-colors">
                    Save Changes
                </button>
            </div>
        </div>
    );
}

function Section({ title, icon: Icon, children }) {
    return (
        <div className="bg-card/50 border border-border/20 rounded-2xl p-6 backdrop-blur-sm">
            <div className="flex items-center gap-2 mb-6 text-foreground">
                <Icon className="w-5 h-5 opacity-70" />
                <h2 className="font-semibold text-lg">{title}</h2>
            </div>
            <div className="space-y-4">
                {children}
            </div>
        </div>
    )
}

function SettingRow({ label, value, color }) {
    return (
        <div className="flex justify-between items-center py-2 border-b border-border/5 last:border-0">
            <span className="text-sm text-muted-foreground">{label}</span>
            <span className={`text-sm font-medium ${color || 'text-foreground'}`}>{value}</span>
        </div>
    )
}

function SettingToggle({ label, active }) {
    return (
        <div className="flex justify-between items-center py-2 border-b border-border/5 last:border-0">
            <span className="text-sm text-muted-foreground">{label}</span>
            <button className={`w-10 h-6 rounded-full relative transition-colors ${active ? 'bg-primary' : 'bg-muted'}`}>
                <span className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-all ${active ? 'left-5' : 'left-1'}`} />
            </button>
        </div>
    )
}
